import type { ColorsPalette } from 'models/colorsPalette';

import { getColorSchemaFromPalette } from './colors';

// Resolved RGBA values for server-side renders (Satori, OG images, etc.).
// Satori resolves CSS custom properties for CSS color/backgroundColor but NOT for
// SVG stroke/fill, so chart lines require literal RGBA rather than var(--…) refs.
// Must stay in sync with the dark-mode token values in globals.css.
export const DEFAULT_CHART_LINE_COLORS_RGBA = [
    'rgba(40, 204, 149, 1)', // Green[10]
    'rgba(64, 143, 255, 1)', // Blue[10]
    'rgba(255, 149, 0, 1)', // Orange[10]
    'rgba(210, 77, 255, 1)', // Purple[10]
];

export const AWARDS_CHART_LINE_COLORS_RGBA = [
    'rgba(255, 232, 120, 1)', // Yellow[40]
    'rgba(255, 255, 255, 0.9)', // Container/Text white-on-dark
    'rgba(255, 174, 61, 1)', // Orange[40]
    'rgba(40, 204, 149, 1)', // Green[10]
];

export const isAwardsTicker = (ticker: string | undefined): boolean => {
    const t = ticker?.toLowerCase() ?? '';
    return t.includes('kxgram') || t.includes('kxoscar');
};

// Share the outcome mapping while letting browser and image renderers use their own palettes.
export function getBalanceOfPowerColorKey(ticker: string, yesSubtitle: string): 'Red' | 'Blue' | 'Purple' | undefined {
    if (!ticker.toUpperCase().startsWith('KXBALANCEPOWERCOMBO-')) return undefined;

    const isRepublicanSweep = yesSubtitle.includes('R-House, R-Senate') || yesSubtitle.includes('Republicans sweep');

    const isDemocraticSweep = yesSubtitle.includes('D-House, D-Senate') || yesSubtitle.includes('Democrats sweep');

    if (isRepublicanSweep) {
        return 'Red';
    }

    if (isDemocraticSweep) {
        return 'Blue';
    }

    return 'Purple';
}

export function getFallbackChartLineColorsRgba(ticker?: string): string[] {
    return isAwardsTicker(ticker) ? AWARDS_CHART_LINE_COLORS_RGBA : DEFAULT_CHART_LINE_COLORS_RGBA;
}

export function getColorFromPalette(
    palette: ColorsPalette | null | undefined,
    isDarkMode: boolean,
    kind: 'primary' | 'secondary',
): string | null {
    if (!palette) return null;
    const schema = getColorSchemaFromPalette(palette, isDarkMode);
    return (kind === 'primary' ? schema.primaryRgba : schema.secondaryRgba) || null;
}
